import React, { forwardRef, useContext } from 'react';

export const MyTableContext = React.createContext({ responsive: true });

interface IProps {
  responsive?: boolean;
  children?: React.ReactNode;
}

const MyTable = forwardRef<HTMLTableElement, IProps>(({ children }, ref) => {
  const { responsive } = useContext(MyTableContext);

  return (
    <table
      ref={ref}
      className={`my-table -sales relative min-w-full border-separate! border-spacing-y-2 bg-transparent max-sm:[&:not(.disable-responsive)]:block ${
        !responsive ? 'disable-responsive' : ''
      }`}
    >
      {children}
    </table>
  );
});

export { default as MyTableBody } from './MyTableBody';
export { default as MyTableCol } from './MyTableCol';
export { default as MyTableRow } from './MyTableRow';
export { default as MyTableHeader } from './MyTableHeader';
export { default as MyTableWrapper } from './MyTableWrapper';

export default MyTable;
